<template>
  <div id="lygcgxm">
    <div class="layui-layout layui-layout-admin">
      <div class="layui-header">
        <div class="layui-title" />
        <ul class="layui-nav layui-layout-right" lay-filter="layadmin-layout-right" style="right: 12px">
          <li class="layui-nav-item" lay-unselect>
            <a layadmin-event="fullscreen" id="fullScreen">
              <i class="layui-icon layui-icon-screen-full" style="color: black"></i>
            </a>
          </li>
          <li class="layui-nav-item" lay-unselect>
            <a style="cursor: pointer" @click="showMsg(0)">
              <i class="layui-icon layui-icon-notice"></i>
              <!-- 如果有新消息，则显示小圆点 -->
              <span class="layui-badge" v-show="msgNum">{{ msgNum }}</span>
            </a>
          </li>
          <li class="layui-nav-item" lay-unselect>
            <a style="cursor: pointer">
              <i class="layui-icon layui-icon-friends"></i>
              <cite v-text="loginUsername"></cite>
            </a>
            <dl class="layui-nav-child">
              <dd>
                <a
                  style="cursor: pointer"
                  @click="loadComponent({ path: '/user/changeInfo', name: 'UserChangeInfo', title: '基本资料' })"
                  >基本资料</a
                >
              </dd>
              <dd>
                <a
                  style="cursor: pointer"
                  @click="loadComponent({ path: '/user/changePw', name: 'UserChangePassowrd', title: '修改密码' })"
                  >修改密码</a
                >
              </dd>
              <hr />
              <dd layadmin-event="logout" style="text-align: center"><a @click="logout()">退出</a></dd>
            </dl>
          </li>
        </ul>
      </div>

      <!-- 侧边菜单 -->
      <div class="layui-side layui-side-menu">
        <div class="layui-side-scroll-one">
          <div>
            <div
              v-for="(item, index) in menus"
              v-show="!item.place && item.show"
              :key="index"
              :class="['a-menu', item.active ? 'aMenu-active' : '']"
              @click="handleMenuClick(item)"
            >
              <i :class="['layui-icon', item.active ? item.activeIcon : item.icon]"></i>
              <p>{{ item.title }}</p>
            </div>
          </div>
          <div>
            <div
              v-for="(item, index) in menus"
              v-show="item.place && item.show"
              :key="index"
              :class="['a-menu', item.active ? 'aMenu-active' : '']"
              @click="handleMenuClick(item)"
            >
              <i :class="['layui-icon', item.active ? item.activeIcon : item.icon]"></i>
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
        <!-- <xx v-if="newsShow" class="news-wrapper" /> -->
        <div class="layui-side-scroll">
          <div class="layui-logo">
            <li class="layui-nav-item layadmin-flexible" lay-unselect>
              <a layadmin-event="flexible" @click="sideFlexible()" title="侧边伸缩">
                <i class="layui-icon shrink-icon-right"></i>
              </a>
            </li>
          </div>
          <Layui-menu
            id="menu"
            :menus="secondMenus"
            :current-menu="currentComponent"
            @menu-click="loadComponent($event)"
          ></Layui-menu>
        </div>
      </div>
      <div class="layadmin-pagetabs">
        <div
          class="layui-icon layadmin-tabs-control layui-icon-prev"
          @click="rollPage('left')"
          style="color: rgb(216 216 216)"
        ></div>
        <div
          class="layui-icon layadmin-tabs-control layui-icon-next"
          @click="rollPage()"
          style="color: rgb(216 216 216)"
        ></div>
        <div class="layui-icon layadmin-tabs-control layui-icon-down">
          <ul class="layui-nav layadmin-tabs-select" lay-filter="layadmin-pagetabs-nav">
            <li class="layui-nav-item">
              <a><span class="layui-nav-more"></span></a>
              <dl class="layui-nav-child">
                <dd @click="closeCurrent()"><a>关闭当前标签页</a></dd>
                <dd @click="closeOther()"><a>关闭其它标签页</a></dd>
                <!-- <dd @click="closeAll()"><a>关闭全部标签页</a></dd> -->
              </dl>
            </li>
          </ul>
        </div>
        <div class="layui-tab">
          <ul class="layui-tab-title head-tab-title" id="LAY_app_tabsheader" lay-filter="LAY_app_tabsheader">
            <li
              v-for="component in sortComponents()"
              :key="component.name + '1'"
              :class="[{ 'layui-this': currentComponent == component }, component.name]"
              @click.stop="loadComponent(component)"
            >
              <div>
                <a v-text="component.title" :title="component.title"></a>
              </div>
              <i class="layui-icon layui-unselect layui-tab-close" @click.stop="closeComponent(component)">ဆ</i>
            </li>
          </ul>
        </div>
      </div>

      <!-- 主体内容 -->
      <div :hidden="bpmShow" class="layui-body">
        <div class="layadmin-tabsbody-item layui-show">
          <!-- 2022.05.27 依据客户要求，每次都刷新组件 -->
          <!-- 2022.09.17 依据客户要求，缓存组件 -->
          <keep-alive :exclude="destroyComponent">
            <component :is="currentComponent.name"></component>
          </keep-alive>
        </div>
      </div>
      <!-- 辅助元素，一般用于移动设备下遮罩 -->
      <div class="layadmin-body-shade" layadmin-event="shade"></div>
      <!-- 配色方案 -->
      <LayuiTheme ref="theme"></LayuiTheme>
    </div>
    <add-bpm v-if="bpmShow" :visible.sync="bpmShow" :type="bpm.type" :info="bpm.info" />
    <!-- 消息 -->
    <div id="LAY_msg" class="layui-layer-content" style="display: none">
      <div class="layui-card-header">消息提醒</div>
      <pub-tabs :list="tabs" @changeTabs="handleChangeTab" :msgNum="msgNum" style="overflow: hidden" @readAll="readAll">
        <template>
          <div class="msg-list">
            <div class="msg-each" v-for="item in msgList" :key="item.MSG_ID" @click="readMessage(item)">
              <p class="msg-hd">
                <span v-if="item.STATUS == 0" class="unread"></span>
                <span v-if="item.STATUS == 1" class="read"></span>
                <span class="msg-sendId">{{ item.MSG_TITLE }}</span>
                <span class="msg-sendTime">{{ item.SEND_TIME }}</span>
              </p>
              <div class="msg-bd">{{ item.MSG_CONTENT }}</div>
            </div>
          </div>
        </template>
      </pub-tabs>
      <!-- <div class="msg-fd">
          <button class="layui-btn layui-textBtn" @click="readAll()">全部标记为已读</button>
          <button class="layui-btn layui-textBtn" @click="msgBtn('check')">查看全部通知</button>
        </div> -->
    </div>

    <div id="LAY_msg_info" class="layui-form" style="padding: 10px 20px; display: none">
      <div class="msginfo">
        <p class="msg-hd">
          <span class="msg-title">{{ msgInfo.SEND_ID_DESC }}</span>
          <span class="msg-sendTime">{{ msgInfo.SEND_TIME }}</span>
        </p>
        <div class="msg-bd">{{ msgInfo.MSG_CONTENT }}</div>
      </div>
      <div class="layui-form-item" style="margin-top: 15px">
        <button class="layui-btn layui-textBtn" @click="layer.closePop('LAY_msg_info')">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import '../../static/style/index.css'
import LayuiTheme from './common/LayuiTheme'
import UserChangePassowrd from './ywpt/user/UserChangePassword'
import UserChangeInfo from './ywpt/user/UserChangeInfo'
import menuConfig from '../support/menuConfig'
import '@logicflow/core/dist/style/index.css'
import '@logicflow/extension/lib/style/index.css'

// import news from './news'
// 原先的流程图
// import addBpm from './workOrder/bpm/addBpm'

// 新的拖拽
import addBpm from './workOrder/newBpm/addBpm'
export default {
  name: 'Index',
  components: { ...menuConfig.getMenuComponents(), UserChangeInfo, UserChangePassowrd, LayuiTheme, addBpm },
  provide: function () {
    return {
      mainProvide: this.mainProvide,
    }
  },
  data() {
    return {
      mainProvide: { toggleSide: false },
      loginUsername: '',
      activeComponents: [],
      destroyComponent: '',
      menus: menuConfig.getMenus(),
      secondMenus: [],
      currentComponent: this.getFirstComponent(menuConfig.getMenus()),
      newsShow: false,
      bpmShow: false,
      bpm: { type: '', info: {} },
      msgList: [], //当前登录用户的消息
      msgInfo: {},
      msgNum: 0,
      finishMsgNum: 0,
      tabs: [],
    }
  },
  mounted() {
    this.tabs = [
      { label: '未读(' + this.msgNum + ')', value: 0, active: true },
      { label: '已读', value: 1, active: false },
    ]
    this.calcMsg()
    Vue.prototype.baseComponent = this
    this.layui.element.render('nav', 'layadmin-layout-right')
    this.layui.element.render('nav', 'layadmin-pagetabs-nav')
    //设置当前登录用户的名称
    this.loginUsername = this.security.getUser().getUname()
    // 监听用户信息修改事件
    this.$bus.$on(this.dict.event.UPDATE_USERINFO, () => {
      this.loginUsername = this.security.getUser().getUname()
    })
    if (this.currentComponent.parent && this.currentComponent.parent.children) {
      this.secondMenus = this.currentComponent.parent.children
    }
    this.activeComponents.push(this.currentComponent)
    window.history.pushState({}, 0, this.currentComponent.path)

    function entryFullScreen() {
      var docE = document.documentElement
      if (docE.requestFullscreen) {
        docE.requestFullscreen()
      } else if (docE.mozRequestFullScreen) {
        docE.mozRequestFullScreen()
      } else if (docE.webkitRequestFullScreen) {
        docE.webkitRequestFullscreen()
      }
    }
    //退出全屏
    function exitFullScreen() {
      var docE = document
      if (docE.exitFullscreen) {
        docE.exitFullscreen()
      } else if (docE.mozCancelFullScreen) {
        docE.mozCancelFullScreen()
      } else if (docE.webkitCancelFullScreen) {
        docE.webkitCancelFullScreen()
      }
    }
    $('#fullScreen').bind('click', function () {
      var fullscreenElement =
        document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
      if (fullscreenElement == null) {
        entryFullScreen()
        $(this).html('<i class="layui-icon layui-icon-screen-restore" style="color: black;"></i>')
      } else {
        exitFullScreen()
        $(this).html('<i class="layui-icon layui-icon-screen-full" style=" color: black;"></i>')
      }
    })
    //菜单折叠，显示提示信息
    $('.layui-layout-admin')
      .on('mouseenter', '*[lay-tips]', function () {
        var e = $(this)
        if ($('#lygcgxm').hasClass('layadmin-side-shrink')) {
          var t = e.attr('lay-tips'),
            i = e.attr('lay-offset'),
            n = e.attr('lay-direction'),
            l = layer.tips(t, this, {
              tips: n || 1,
              time: -1,
              success: function (e, a) {
                i && e.css('margin-left', i + 'px')
              },
            })
          e.data('index', l)
        }
      })
      .on('mouseleave', '*[lay-tips]', function () {
        layer.close($(this).data('index'))
      })
    $('.news-wrapper').hide()
    // 监听流程管理
    this.$bus.$on('showBpm', (type, data) => {
      this.bpmShow = true
      this.bpm = { type: type, info: data }
    })
    this.$bus.$on('hideBpm', () => {
      this.bpmShow = false
    })
    this.layui.element.on('nav(layadmin-pagetabs-nav)', function (e) {
      var a = e.parent()
      a.removeClass('layui-this'), a.parent().removeClass('layui-show')
    })
  },
  methods: {
    refresh() {
      window.location.reload()
    },
    logout() {
      this.layer.openConfirm(
        '确定要注销并退出系统吗？',
        () => {
          this.security.logout()
          this.$bus.$emit(this.dict.event.LOGOUT)
        },
        null,
        { targetEl: $('body') }
      )
    },
    closeComponent(currentMenu) {
      if (this.activeComponents.length != 1) {
        this.destroyComponent = currentMenu.name
        if (this.activeComponents.length > 1) {
          this.activeComponents.remove(currentMenu)
          this.currentComponent = this.activeComponents[this.activeComponents.length - 1]
          this.afterRollPage()
        }
      }
    },
    getFirstComponent(menus) {
      var first = null
      var pathname = window.location.pathname
      var target = []
      //如果地址栏有路径，那么我们根据路径来找到对应的加载组件
      if (pathname) {
        this.findComponentByPathName(pathname, menus, target)
        first = target[0]
      }
      //如果找不到，可能因为该用户没有路径对应的组件权限，那么我们找到该用户所有可见的菜单中第一个
      if (first == null && menus.length > 0) {
        //(first = menus[0]).isLeaf || (first = menus[0].children[0]).isLeaf || (first = menus[0].children[0].children[0]).isLeaf;
        this.findFirstAviableMenu(menus, target)
        first = target[0]
      }
      //如果扎到要加载的组件了，这里再找一下上级菜单（最左侧的）
      if (first && first.parent) {
        menus.forEach((item) => (item.active = false))
        //父菜单和当前菜单都显示
        first.active = first.parent.active = true
      }
      //如果没有第二级菜单
      if (first && !first.children) {
        menus.forEach((item) => (item.active = false))
        first.active = true
        this.$nextTick(() => {
          this.secondMenusStyle(first) //设置第二菜单的样式
        })
      }
      first = first ? first : {}
      return first
    },
    findFirstAviableMenu(menus, result) {
      for (var i = 0; i < menus.length; i++) {
        var menu = menus[i]
        if (!result[0] && (menu.show || menu.ignore) && menu.isLeaf) {
          result[0] = menu
          break
        } else {
          if (menu.children) {
            this.findFirstAviableMenu(menu.children, result)
          }
        }
      }
    },
    findComponentByPathName(pathname, dataset, target) {
      if (target.length != 1) {
        for (var i = 0; i < dataset.length; i++) {
          var currentMenu = dataset[i]
          var currentPathname = currentMenu.path
          if ((currentMenu.show || currentMenu.ignore) && currentPathname && currentPathname.indexOf(pathname) >= 0) {
            if (!target[0]) {
              target[0] = currentMenu
            }
            break
          }
          if (currentMenu.children != null && currentMenu.children.length > 0) {
            this.findComponentByPathName(pathname, currentMenu.children, target)
          }
        }
      }
    },
    loadComponent(currentMenu) {
      this.destroyComponent = ''
      if (!currentMenu.path) return
      for (var i = 0; i < this.activeComponents.length; i++) {
        var item = this.activeComponents[i]
        if (item.name == currentMenu.name) {
          window.history.pushState({}, 0, currentMenu.path)
          this.currentComponent = item
          if (item.name == 'viewBoard') {
            this.secondMenusStyle(item)
          }
          return
        }
      }
      this.activeComponents.push((this.currentComponent = currentMenu))
      window.history.pushState({}, 0, currentMenu.path)
      this.afterRollPage()
      // this.closeOther()
    },
    loadComponentByName(name) {
      let result = []
      this.findComponentByName(name, this.menus, result)
      this.loadComponent(result[0])
    },
    /**
     * 灵活的加载新组件
     * 1.支持传递参数 param
     * 2.支持同组件不同实例来加载
     * 新组建： 意思是通过传递参数创建的组件
     * @param menuName  创建新组建参考的对象
     * @param config
     * config {
     *  uniqueName: // 如果配置了该属性那么加载组件的时候会先找是否存在以改名字命名的组件，如果存在直接取出，否则新建一个改名字的组件
     * }
     */
    smartLoadComponent(menuName, param, config) {
      config = config ? config : {}
      if (config.uniqueName) {
        var activeComponents = this.activeComponents
        for (var i = 0; i < this.activeComponents.length; i++) {
          var item = this.activeComponents[i]
          if (item.name == config.uniqueName) {
            this.loadComponent(item)
            return
          }
        }
      }
      let result = []
      this.findComponentByName(menuName, this.menus, result)
      let menuComponent = result[0]
      let component = menuConfig.getMenuComponentByName(menuComponent.name)
      let copyComponent = $.extend(true, {}, component)
      let dataFunc = copyComponent.data
      copyComponent.data = function () {
        let data = dataFunc.call(this)
        data.tabParam = param
        return data
      }
      //每次打开都创建一个独立的组件，不会因为已经加载过不再加载了
      let newComponentName = config.uniqueName ? config.uniqueName : menuComponent.name + '_' + this.uuid()
      //一定要删除_Ctor,否则Vue会认为是同一个实例
      delete copyComponent._Ctor
      copyComponent.name = newComponentName
      delete menuComponent.parent
      let cloneMenu = $.extend(true, {}, menuComponent)
      cloneMenu.name = newComponentName
      if (param.title) {
        cloneMenu.title = param.title
      }
      //@Todo 需要动态移除
      Vue.component(newComponentName, copyComponent)
      param.cloneMenu = cloneMenu
      param.sourceMenu = this.currentComponent
      this.loadComponent(cloneMenu)
    },
    closeComponentByName(name) {
      let result = []
      this.findComponentByName(name, this.menus, result)
      this.closeComponent(result[0])
    },
    //菜单折叠
    sideFlexible() {
      $('#lygcgxm').toggleClass('layadmin-side-shrink')
      if ($('#lygcgxm').hasClass('layadmin-side-shrink')) {
        $('.layui-logo .layui-icon').removeClass('shrink-icon-right')
        $('.layui-logo .layui-icon').addClass('shrink-icon-left')
      } else {
        $('.layui-logo .layui-icon').removeClass('shrink-icon-left')
        $('.layui-logo .layui-icon').addClass('shrink-icon-right')
      }
    },
    menuFlexible() {
      if ($('#lygcgxm').hasClass('layadmin-side-shrink')) {
        $('#lygcgxm').removeClass('layadmin-side-shrink')
        $('.layui-logo .layui-icon').removeClass('shrink-icon-left')
        $('.layui-logo .layui-icon').addClass('shrink-icon-right')
      }
    },
    findComponentByName(name, menus, result) {
      for (var i = 0; i < menus.length; i++) {
        var menu = menus[i]
        if (!result[0] && (menu.show || menu.ignore) && menu.name == name && menu.isLeaf) {
          result[0] = menu
          break
        } else {
          if (menu.children) {
            this.findComponentByName(name, menu.children, result)
          }
        }
      }
    },
    /**
     * 一级菜单点击事件
     */
    handleMenuClick(params) {
      this.secondMenusStyle(params)
      // 消息功能
      if (params.name === 'xx') {
        var result = []
        this.findComponentByName('xx', this.menus, result)
        if (result[0]) {
          this.loadComponent(result[0])
        }
      } else if (
        params.name === 'viewBoard' ||
        params.name === 'Statistics' ||
        params.name === 'repairStatisticsManage'
      ) {
        this.loadComponent(params)
      }
      this.secondMenus = params.children
      this.menus.forEach((item) => (item.active = false))
      params.active = true
    },
    //模拟点击二级菜单
    clickSecondMenuByName(menuName) {
      let result = []
      this.findComponentByName(menuName, this.menus, result)
      let curSecondMenu = result[0]
      let parentMenu = curSecondMenu.parent
      //先模拟点击一级菜单
      this.handleMenuClick(parentMenu)
      //再点击二级菜单
      this.loadComponent(curSecondMenu)
    },
    //设置第二菜单的样式
    secondMenusStyle(params) {
      if (params.name === 'xx') {
        this.newsShow = true
        $('.layui-layout-admin .layui-side').css('width', '424px')
        $('.layui-layout-admin .layui-body').css('left', '424px')
        $('.layadmin-pagetabs').css('left', '424px')
      } else if (
        params.name === 'viewBoard' ||
        params.name === 'Statistics' ||
        params.name === 'repairStatisticsManage'
      ) {
        $('.layui-layout-admin .layui-side').css('width', '64px')
        $('.layui-layout-admin .layui-body').css('left', '64px')
        $('.layadmin-pagetabs').css('left', '64px')
        $('.layui-layout-admin .layui-side-scroll').css('display', 'none')
        $('.layui-footer').css('left', '0')
        setTimeout(() => {
          this.mainProvide.toggleSide = !this.mainProvide.toggleSide
        }, 300)
      } else {
        this.newsShow = false
        $('.layui-layout-admin .layui-side').removeAttr('style')
        $('.layui-layout-admin .layui-body').removeAttr('style')
        $('.layadmin-pagetabs').removeAttr('style')
        $('.layui-layout-admin .layui-side-scroll').removeAttr('style')
        $('.layui-footer').removeAttr('style')
      }
    },
    sortComponents() {
      var arr = []
      var arr2 = []
      for (var i = 0; i < this.activeComponents.length; i++) {
        var item = this.activeComponents[i]
        if (item.name == 'viewBoard') {
          arr.push(item)
        } else {
          arr2.push(item)
        }
      }
      return [...arr, ...arr2]
    },
    //消息相关
    //统计消息数量
    calcMsg() {
      let user = this.security.getUser()
      let userId = user.getUid()
      let fid = user.getF_id()
      let userRole = user.getRoles().join(',')
      let tableName = 'YW_MESSAGE'
      //let p2 = {STATUS: 0};
      var p2 = { STATUS: 0 }
      if (userRole == 'gcs' || userRole == 'xmjl') {
        p2.RECEIVE_ID = fid
      } else if (userRole == 'kf') {
        p2.TYPE = 1
      } else if (userRole == 'zj') {
        p2.TYPE = 3
      } else {
        return
      }
      this.api.queryList(tableName, { p2: p2, p9: 'COUNT(*) NUM' }, 'calcMsg').then((response) => {
        let result = response.result
        result = result[0]
        this.msgNum = this.baseComponent.msgNum = result.NUM
        this.$set(this.tabs[0], 'label', '未读(' + this.msgNum + ')')
      })

      p2.STATUS = 1
      this.api.queryList(tableName, { p2: p2, p9: 'COUNT(*) NUM' }, 'calcMsg').then((response) => {
        let result = response.result
        result = result[0]
        this.finishMsgNum = result.NUM
        this.$set(this.tabs[1], 'label', '已读(' + this.finishMsgNum + ')')
      })
    },
    // 显示消息列表
    showMsg(status) {
      let popId = 'LAY_msg'
      let width = '500px'
      $('.layui-layer-shade').length == 0
        ? this.layer.openConfigPopRight({ popId: popId, width: width, targetEl: $('body') })
        : ''
      let tableName = 'YW_MESSAGE'
      let user = this.security.getUser()
      let userId = user.getUid()
      let fid = user.getF_id()
      let userRole = user.getRoles().join(',')
      let p2 = { 'STATUS:1': status }
      if (userRole == 'gcs' || userRole == 'xmjl') {
        //工程师、项目经理
        p2.RECEIVE_ID = fid
      } else if (userRole == 'kf') {
        //客服
        p2.TYPE = 1
      } else if (userRole == 'zj') {
        //总监
        p2.TYPE = 3
      } else {
        return
      }
      let requestId = 'queryMsg'
      this.api.queryList(tableName, { p2: p2, p10: ['SEND_TIME:DESC'] }, requestId).then((response) => {
        let result = response.result
        this.msgList = result
      })
    },
    readMessage(msgInfo) {
      this.msgInfo = msgInfo
      if (this.msgInfo.STATUS == 0) {
        this.msgList.remove(msgInfo)
        this.msgInfo.STATUS = 1
        let saveRow = { IS_NEW: false }
        saveRow.MSG_ID = msgInfo.MSG_ID
        saveRow.STATUS = 1
        this.api.save('YW_MESSAGE', saveRow, 'readMessage').then(() => {
          this.calcMsg()
        })
      }
    },
    readAll() {
      this.calcMsg()
      this.showMsg(0)
    },
    /**
     * tabs改变事件
     */
    handleChangeTab(params) {
      if (params === 0) {
        this.showMsg(0)
      } else {
        this.showMsg(1)
      }
    },
    /**
     * 消息功能按钮
     */
    msgBtn(type) {
      if (type === 'check') {
        this.layer.closePop('LAY_msg')
        this.currentFirstMenu = this.menus[1]
        this.loadComponentByName('message')
      } else {
      }
    },
    afterRollPage() {
      setTimeout(() => {
        var width = $('#LAY_app_tabsheader').width()
        var liEls = $('#LAY_app_tabsheader').find('li')
        var sumWidth = 0
        for (var i = 0; i < liEls.length; i++) {
          sumWidth += $(liEls[i]).width() + 40 + 15
        }
        $('.layui-icon-prev').css('color', 'rgb(216 216 216)')
        $('.layui-icon-next').css('color', 'rgb(216 216 216)')
        var left = $('#LAY_app_tabsheader').css('left')
        if (left != '0px') {
          if (left[0] == '-') {
            $('.layui-icon-prev').css('color', 'black')
          }
        } else {
          if (sumWidth > width) {
            $('.layui-icon-next').css('color', 'black')
          }
        }
      }, 300)
    },
    closeCurrent() {
      this.closeComponent(this.currentComponent)
    },
    closeOther() {
      var activeMenus = this.activeComponents
      var arr = []
      for (var i = 0; i < activeMenus.length; i++) {
        var component = activeMenus[i]
        if (component != this.currentComponent) {
          arr.push(component)
        }
      }
      if (arr.length > 0) {
        arr.forEach((e) => {
          this.closeComponent(e)
        })
      }
    },
    rollPage(e, t) {
      var that = this
      var a = $
      var i = a('#LAY_app_tabsheader'),
        n = i.children('li'),
        l = (i.prop('scrollWidth'), i.outerWidth()),
        s = parseFloat(i.css('left'))
      if ('left' === e) {
        if (!s && s <= 0) {
          that.afterRollPage()
          return
        }

        var r = -s - l
        n.each(function (e, t) {
          var n = a(t),
            l = n.position().left
          if (l >= r) {
            i.css('left', -l)
            that.afterRollPage()
            return !1
          }
        })
      } else
        'auto' === e
          ? !(function () {
              var e,
                r = n.eq(t)
              if (r[0]) {
                if (((e = r.position().left), e < -s)) {
                  i.css('left', -e)
                  that.afterRollPage()
                  return
                }

                if (e + r.outerWidth() >= l - s) {
                  var o = e + r.outerWidth() - (l - s)
                  n.each(function (e, t) {
                    var n = a(t),
                      l = n.position().left
                    if (l + s > 0 && l - s > o) {
                      i.css('left', -l)
                      that.afterRollPage()
                      return !1
                    }
                  })
                }
              }
            })()
          : n.each(function (e, t) {
              var n = a(t),
                r = n.position().left
              if (r + n.outerWidth() >= l - s) {
                i.css('left', -r)
                that.afterRollPage()
                return !1
              }
            })
    },
  },
}
</script>
<style scoped>
#LAY_msg .layui-card-body {
  height: calc(100% - 120px);
}
#LAY_msg .layui-tab-content {
  height: calc(100% - 60px);
}
.msg-list {
  height: 100%;
  overflow-y: scroll;
}
.msg-each {
  height: 90px;
  padding: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.msg-hd {
  margin: 10px 0px;
}
.msg-each:hover {
  background-color: #eae7e7;
}
.unread {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #e24d4d;
  vertical-align: middle;
}
.read {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #5fb878;
  vertical-align: middle;
}
.msg-title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin: 0 10px;
}
.msg-sendTime {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  float: right;
}
.msg-list .msg-bd {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  margin-bottom: 5px;
  cursor: pointer;
}
.msg-fd {
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  background-color: #fafafa;
}
.layui-btn.layui-textBtn {
  background: none;
  color: #00a0e9;
}
.layadmin-pagetabs {
  z-index: 990;
  background: white;
}
.layadmin-tabs-select.layui-nav .layui-nav-child {
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue